<template>
  <div style="display: flex; flex-direction: column">
    <el-input
      :value="txtSurchargeTerms"
      :placeholder="disabled ? '' : $t('SeaExport.DoubleClickToAddExtraChargeClause')"
      type="textarea"
      :rows="4"
      @dblclick.native="selectSurchargeTermsDialog.rowData=job.surchargeTerms||[];selectSurchargeTermsDialog.visible=true"
    />
    <!-- 附加费条款弹窗 -->
    <select-surcharge-terms-dialog
      :visible.sync="selectSurchargeTermsDialog.visible"
      :job-uuid="job.uuid"
      :row-data="selectSurchargeTermsDialog.rowData"
      :disabled="disabled"
      :append-to-body="true"
      @callback="handleSurchargeTerms"
    />
  </div>
</template>

<script>
import selectSurchargeTermsDialog from '@/components/Cargo/Job/selectSurchargeTermsDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SeSurchargeTerms',
  components: { selectSurchargeTermsDialog },
  props: {
    job: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      txtSurchargeTerms: '',
      selectSurchargeTermsDialog: {
        rowData: [],
        visible: false
      }
    }
  },
  created() {
    this.mergeSurchargeTerms()
  },
  methods: {
    handleSurchargeTerms(data) {
      if (!this.job.surchargeTerms) {
        this.job.surchargeTerms = []
      }
      const surchargeTerms = this.job.surchargeTerms
      surchargeTerms.splice(0, surchargeTerms.length)
      surchargeTerms.push(...data)
      this.mergeSurchargeTerms()
    },
    mergeSurchargeTerms() {
      let text = ''
      if (this.job.surchargeTerms) {
        for (const item of this.job.surchargeTerms) {
          if (item.deleted) {
            continue
          }
          if (text) {
            text += '\n'
          }
          const chargeItemName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
          if (typeof chargeItemName === 'string' && chargeItemName.startsWith('HDS')) {
            this.form.hds = true
          }
          text += `${chargeItemName}：${item.terms}`
        }
      }
      this.txtSurchargeTerms = text
    }
  }
}
</script>
